// const jwt = require('jsonwebtoken');

import jwtEncode from "jwt-encode";
import jwtDecode from "jwt-decode";

export const jwtEncodeData = <T extends Record<string, unknown>>(data: T) =>
    jwtEncode(data, process.env.NEXT_PUBLIC_JWT_SECRET || "super secret");

export const jwtDecodeData = (jwtToken: string) => jwtDecode(jwtToken);
